import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";

const STORAGE_KEY = "aristeia_cookie_consent";

function readConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

const STRINGS = {
  ca: {
    title: "Galetes & privacitat",
    body: "Fem servir galetes tècniques per fer funcionar la web i, amb el teu consentiment, galetes analítiques per millorar-la. Pots canviar la teva tria en qualsevol moment.",
    accept: "Acceptar totes",
    reject: "Només les essencials",
    more: "Política de galetes",
  },
  es: {
    title: "Cookies & privacidad",
    body: "Usamos cookies técnicas para que la web funcione y, con tu consentimiento, cookies analíticas para mejorarla. Puedes cambiar tu elección en cualquier momento.",
    accept: "Aceptar todas",
    reject: "Solo las esenciales",
    more: "Política de cookies",
  },
  en: {
    title: "Cookies & privacy",
    body: "We use strictly-necessary cookies to run the site and, with your consent, analytics cookies to improve it. You can update your choice at any time.",
    accept: "Accept all",
    reject: "Essential only",
    more: "Cookie policy",
  },
};

export function CookieConsent() {
  const { lang } = useLang();
  const [visible, setVisible] = useState(false);
  const s = STRINGS[lang] || STRINGS.es;

  useEffect(() => {
    const t = setTimeout(() => {
      if (!readConsent()) setVisible(true);
    }, 700);
    return () => clearTimeout(t);
  }, []);

  const save = (analytics) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        essential: true,
        analytics,
        decided_at: new Date().toISOString(),
      }),
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3 sm:px-6 sm:pb-6 pointer-events-none"
      data-testid="cookie-consent"
    >
      <div className="pointer-events-auto mx-auto max-w-3xl rounded-2xl border border-brand-tan/40 bg-brand-cream/95 backdrop-blur-xl shadow-[0_20px_60px_-20px_rgba(60,40,24,0.4)] p-5 sm:p-6">
        <div className="sm:flex sm:items-start sm:gap-6">
          <div className="flex-1">
            <p className="text-[10px] tracking-[0.4em] uppercase font-bold text-brand-tan">
              ARISTEIA · {s.title}
            </p>
            <p className="mt-2 text-sm text-brand-brown leading-relaxed">
              {s.body}
            </p>
            <Link
              to="/legal/cookies"
              className="inline-block mt-2 text-[11px] tracking-[0.2em] uppercase font-bold text-brand-brown underline underline-offset-4 decoration-brand-tan/60 hover:decoration-brand-brown"
              data-testid="cookie-more"
            >
              {s.more} →
            </Link>
          </div>
          <div className="mt-4 sm:mt-0 grid grid-cols-2 sm:flex sm:flex-col gap-2 sm:w-44">
            <button
              type="button"
              onClick={() => save(true)}
              data-testid="cookie-accept"
              className="px-4 py-3 rounded-xl bg-brand-brown text-brand-cream font-bold tracking-[0.18em] uppercase text-[11px] hover:bg-brand-deep-brown transition-colors active:scale-[0.98]"
            >
              {s.accept}
            </button>
            <button
              type="button"
              onClick={() => save(false)}
              data-testid="cookie-reject"
              className="px-4 py-3 rounded-xl border border-brand-tan/50 text-brand-brown font-bold tracking-[0.18em] uppercase text-[11px] hover:bg-white transition-colors active:scale-[0.98]"
            >
              {s.reject}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
